import React from "react";
import "./GuidancePage.css";

import FooterSection from "../FooterSection/FooterSection"
const GuidancePage = () => {
  return (
    <>
    <div className="guidance-container">
      {/* PAGE 1 */}

      <h1 className="main-title">ZikRme User Guidance Center</h1>

      <h3 className="sub-title">Learn How to Use ZikRme Easily & Smartly</h3>

      <p>Welcome to ZikRme!</p>

      <p>
        This guide will help you understand how to search, book, pay, cancel,
        and manage your services on our platform.
      </p>

      <p>
        ZikRme is a marketplace platform that connects users with independent
        service providers such as hotels, cab operators, restaurants, activity
        organizers, and more.
      </p>

      <hr />

      <h2 className="guidance-h2">How ZikRme Works</h2>

      <p>Using ZikRme is simple:</p>

      <ol className="guidance-ol">
        <li className="guidance-li">Search for the service you need</li>
        <li className="guidance-li">Compare available options</li>
        <li className="guidance-li">Enter booking details</li>
        <li className="guidance-li">Complete payment</li>
        <li className="guidance-li">Receive confirmation via email or app</li>
      </ol>

      <p>Your booking is confirmed only after successful payment.</p>

      <hr />

      <h2 className="guidance-h2">Creating an Account</h2>

      <p>To use ZikRme:</p>

      <ul className="guidance-ul">
        <li className="guidance-li">
          Sign up using a valid mobile number or email
        </li>
        <li className="guidance-li">Provide accurate personal details</li>
        <li className="guidance-li">Only one account per user is allowed</li>
        <li className="guidance-li">
          Providing false information may result in account suspension
        </li>
      </ul>

      <p>Always keep your login credentials secure.</p>

      <hr />

      <h2 className="guidance-h2">How to Make a Booking</h2>

      <h4>Hotel Booking</h4>

      <ul className="guidance-ul">
        <li className="guidance-li">Select check-in and check-out dates</li>
        <li className="guidance-li">Choose room type</li>
        <li className="guidance-li">Enter guest details</li>
        <li className="guidance-li">Complete payment</li>
        <li className="guidance-li">Receive booking confirmation</li>
      </ul>

      <h4>Cab Booking</h4>
      <ul className="guidance-ul">
        <li className="guidance-li">Enter pickup and drop location</li>
        <li className="guidance-li">Select date and time</li>
        <li className="guidance-li">Confirm and pay</li>
      </ul>

      <h4>Restaurant Reservation</h4>
      <ul className="guidance-ul">
        <li className="guidance-li">Select date and time</li>
        <li className="guidance-li">Choose number of guests</li>
        <li className="guidance-li">Confirm reservation</li>
      </ul>

      <hr />

      {/* PAGE 2 */}

      <h2 className="guidance-h2">Payments</h2>

      <p>We accept:</p>
      <ul className="guidance-ul">
        <li className="guidance-li">UPI</li>
        <li className="guidance-li">Debit/Credit Cards</li>
        <li className="guidance-li">Net Banking</li>
        <li className="guidance-li">EMI options (if available)</li>
      </ul>

      <p>Important:</p>
      <ul className="guidance-ul">
        <li className="guidance-li">Cash payments are not accepted.</li>
        <li className="guidance-li">
          A booking is confirmed only after payment verification.
        </li>
      </ul>

      <hr />

      <h2 className="guidance-h2">Partial Payments</h2>

      <p>For selected services, partial payment may be allowed.</p>

      <p>In such cases:</p>
      <ul className="guidance-ul">
        <li className="guidance-li">
          An advance amount is paid during booking
        </li>
        <li className="guidance-li">
          Remaining amount may be payable as per vendor terms
        </li>
      </ul>

      <p>Always review payment details before confirming.</p>

      <hr />

      {/* PAGE 4 */}

      <h2 className="guidance-h2">Cancelling a Booking</h2>

      <p>To cancel:</p>

      <ol className="guidance-ol">
        <li className="guidance-li">Go to “My Bookings”</li>
        <li className="guidance-li">Select the booking</li>
        <li className="guidance-li">Click Cancel</li>
      </ol>

      <p>Refund eligibility depends on:</p>

      <ul className="guidance-ul">
        <li className="guidance-li">Time of cancellation</li>
        <li className="guidance-li">Vendor policy</li>
        <li className="guidance-li">Booking type</li>
      </ul>

      <p>Please review cancellation terms before booking.</p>

      <hr />

      <h2 className="guidance-h2">Refunds</h2>

      <p>Default refund method:</p>
      <p>Refunds are credited to the ZikRme Wallet.</p>

      <p>Exception:</p>
      <p>
        In verified medical emergency cases, refunds may be processed to the
        original payment method.
      </p>

      <p>Refund timeline:</p>
      <p>
        Typically 5–15 working days, depending on verification and payment
        processing.
      </p>

      <p>Note:</p>
      <p>Convenience or platform fees are non-refundable.</p>

      <hr />

      <h2 className="guidance-h2">Using the ZikRme Wallet</h2>

      <ul className="guidance-ul">
        <li className="guidance-li">
          Wallet balance can be used for future bookings
        </li>
        <li className="guidance-li">Wallet balance is non-transferable</li>
        <li className="guidance-li">
          Wallet balance is not withdrawable unless specified
        </li>
      </ul>

      <p>You can check your wallet balance in your account dashboard.</p>

      <hr />

      <h2 className="guidance-h2">Communicating with Vendors</h2>

      <ul className="guidance-ul">
        <li className="guidance-li">
          Vendor contact details are provided in booking confirmation
        </li>
        <li className="guidance-li">
          Always share your Booking ID when contacting a vendor
        </li>
        <li className="guidance-li">
          Avoid making payments outside the platform
        </li>
      </ul>

      <p>If you face issues, contact ZikRme support immediately.</p>

      <hr />

      <h2 className="guidance-h2">Important User Guidelines</h2>

      <p>Users must:</p>

      <ul className="guidance-ul">
        <li className="guidance-li">Provide accurate information</li>
        <li className="guidance-li">Avoid fraudulent activity</li>
        <li className="guidance-li">Avoid fake bookings</li>
        <li className="guidance-li">Avoid chargeback misuse</li>
        <li className="guidance-li">Treat vendors respectfully</li>
      </ul>

      <p>Violation of platform rules may result in account suspension.</p>

      <hr />

      <h2 className="guidance-h2">Avoiding No-Show</h2>

      <p>To avoid penalties:</p>

      <ul className="guidance-ul">
        <li className="guidance-li">Arrive on time</li>
        <li className="guidance-li">Inform vendor in case of delay</li>
        <li className="guidance-li">Review booking time carefully</li>
      </ul>

      <p>No-shows may result in non-refundable bookings.</p>

      <hr />

      <h2 className="guidance-h2">Safety Tips</h2>

      <ul className="guidance-ul">
        <li className="guidance-li">Confirm booking details in advance</li>
        <li className="guidance-li">Keep personal belongings secure</li>
        <li className="guidance-li">
          Follow local laws and safety regulations
        </li>
        <li className="guidance-li">
          Consider travel insurance for high-value bookings
        </li>
      </ul>

      <hr />

      <h2 className="guidance-h2">If You Face an Issue</h2>
      {/* ISSUE STEPS */}

      <p>Step 1: Contact the vendor</p>
      <p>Step 2: Contact ZikRme support</p>
      <p>Step 3: Provide booking ID</p>
      <p>Step 4: Attach screenshots or proof</p>

      <p>Our team will review and assist accordingly.</p>

      <hr />

      {/* FAQ */}

      <h2 className="guidance-h2">Frequently Asked Questions</h2>

      <p>
        <strong>Why was my refund credited to wallet?</strong>
      </p>
      <p>Wallet is the default refund mode.</p>

      <p>
        <strong>
          My payment was deducted but booking not confirmed. What should I do?
        </strong>
      </p>
      <p>Contact support for transaction verification.</p>

      <p>
        <strong>Will my coupon be reissued after cancellation?</strong>
      </p>
      <p>Promotion coupons may expire upon cancellation.</p>

      <hr />

      {/* SMART BOOKING */}

      <h2 className="guidance-h2">Smart Booking Tips</h2>

      <ul className="guidance-ul">
        <li className="guidance-li">Book early during peak season</li>
        <li className="guidance-li">
          Review cancellation policy before confirming
        </li>
        <li className="guidance-li">Check vendor ratings</li>
        <li className="guidance-li">Save booking confirmation</li>
      </ul>

      <hr />

      {/* SUPPORT */}

      <h2 className="guidance-h2">Need Assistance?</h2>

      <p>Support Email: support@zikrme.com</p>
      <p>Response time depends on working hours and case complexity.</p>
      
    </div>
    <FooterSection/>
    </>
  );
};

export default GuidancePage;
